import { render } from "./CreateCollection.vue?vue&type=template&id=7846f13f"
import script from "./CreateCollection.vue?vue&type=script&lang=js"
export * from "./CreateCollection.vue?vue&type=script&lang=js"

import "./CreateCollection.vue?vue&type=style&index=0&id=7846f13f&lang=css"
script.render = render

export default script